import { render, staticRenderFns } from "./TabPlaceholder.vue?vue&type=template&id=16fbecd2&scoped=true&"
import script from "./TabPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TabPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./TabPlaceholder.vue?vue&type=style&index=0&id=16fbecd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbecd2",
  null
  
)

export default component.exports